import { useEffect, useState, useRef, useCallback } from 'react';
import CarteiraConsolidadaService from '../../services/CarteiraData';
import { FatosContainer, FatoContainer, Flag } from './styles';
import { AiOutlineArrowRight } from 'react-icons/ai';
import moment from 'moment';
import { FatosRelevantesLoader } from '../../jsx/components/LoadingModels';

const ListFatosRelevantes = ({ slug, type }) => {
  const [fatos, setFatos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [nextCursor, setNextCursor] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  const observer = useRef();
  const lastFatoElementRef = useCallback(
    (node) => {
      if (loading || !hasMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          getFatos(nextCursor);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore, nextCursor]
  );

  const carteiraconsolidadasService = new CarteiraConsolidadaService();
  const formatDate = (dateStr) => moment(dateStr).format('DD/MM/YYYY');

  useEffect(() => {
    getFatos(); // primeira chamada sem cursor
  }, []);

  const getFatos = async (cursor = null) => {
    setLoading(true);
    try {
      let response;

      if (type === 'FII') {
        response = await carteiraconsolidadasService.getFatosRelevantesFII(
          slug,
          cursor
        );
      } else {
        const slugSemSA = slug.replace('.SA', '');
        response = await carteiraconsolidadasService.getFatosRelevantes(
          slugSemSA,
          cursor
        );
      }

      const newFatos = response.results || [];
      setFatos((prev) => [...prev, ...newFatos]);

      // Extrair cursor do `next`
      if (response.next) {
        const url = new URL(response.next);
        const newCursor = url.searchParams.get('cursor');
        console.log(newCursor);
        setNextCursor(newCursor);
        setHasMore(true);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error('Erro ao buscar fatos:', error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FatosContainer>
      {fatos.map((fato, index) => {
        const isLast = index === fatos.length - 1;
        return (
          <FatoContainer key={index} ref={isLast ? lastFatoElementRef : null}>
            <Flag>{fato.Asset}</Flag>
            <p>{fato.News}</p>
            <span>Publicado em: {formatDate(fato.Data)}</span>
            <a target="_blank" href={fato.Download}>
              Ver comunicado completo
              <AiOutlineArrowRight
                style={{ marginBottom: '2px', marginLeft: '5px' }}
              />
            </a>
          </FatoContainer>
        );
      })}

      {loading && <FatosRelevantesLoader />}

      {!loading && fatos.length === 0 && (
        <div>
          Nada a exibir <br />
          <span style={{ fontSize: '15px' }}>
            Não há fatos relevantes sobre a empresa.
          </span>
        </div>
      )}
    </FatosContainer>
  );
};

export default ListFatosRelevantes;
